import {
  isFriendComplete,
  useMatchmakerFriendStore,
} from '@entities/matchmaker';

import styles from './MatchmakerHome.module.scss';
import { FriendSetup } from '../../FriendSetup';
import { FriendLine } from '../FriendLine';
import { MatchmakerDeck } from '../MatchmakerDeck';

/** The friend line's 44 px and DatingHome's 8 px gap under it. */
export const FRIEND_LINE_HEIGHT = 52;

export type MatchmakerHomeProps = {
  /** The height of DatingHome's own controls above, in px. */
  topOffset: number;
};

/**
 * Matchmaker mode: «Кого сосватаем?» until the friend is known, then the
 * friend line over the deck.
 */
export const MatchmakerHome = ({ topOffset }: MatchmakerHomeProps) => {
  const friend = useMatchmakerFriendStore((state) => state.friend);

  if (!isFriendComplete(friend)) {
    return (
      <div className={styles.setup}>
        <FriendSetup isEmbedded />
      </div>
    );
  }

  return (
    <>
      <div className={styles.friendLine}>
        <FriendLine friend={friend} />
      </div>
      <MatchmakerDeck
        friend={friend}
        topOffset={topOffset + FRIEND_LINE_HEIGHT}
      />
    </>
  );
};
